<template>
  <div class="recherche_area">
    <div id="find_what">
      <a-button
        @click="searchWhat = 'A'"
        type="ghost"
        shape="round"
        size="large"
        :style="[
          searchWhat == 'A'
            ? { backgroundColor: 'teal', color: 'white' }
            : { backgroundColor: 'white' },
        ]"
        style="margin: 20px"
      >
        Assuré
      </a-button>

      <a-button
        @click="searchWhat = 'E'"
        type="ghost"
        shape="round"
        size="large"
        :style="[
          searchWhat == 'E' ? { backgroundColor: 'brown', color: 'white' } : {},
        ]"
        style="margin: 20px"
      >
        Entreprise
      </a-button>
    </div>

    <div class="search_input">
      <a-input-search
        v-model:value="searchInput"
        style="border-radius: 50px"
        size="large"
        :placeholder="placeHolder"
      ></a-input-search>
      <div v-if="noResult" id="no_result">Aucune résultat</div>
    </div>

    <AssureInfo v-if="showAssureInfo" />

    <div v-else class="search_result">
      <div v-if="searchWhat == 'A'">
        <div
          v-for="a in searchedAssure.slice(0, 30)"
          :key="a.id"
          @click="getAssureInfo(a.s)"
          class="a_card"
          :style="[
            a.v == 1
              ? {
                  borderBottom: '2px solid green',
                }
              : {
                  borderBottom: '2px solid red',
                },
          ]"
        >
          <div style="font-size: 1.2em">
            <strong>{{ a.f }}</strong> {{ a.l }}
          </div>
          <div style="color: grey">
            {{ a.s }}
          </div>
        </div>
      </div>

      <div v-if="searchWhat == 'E'">
        <div
          v-for="a in searchedAssure.slice(0, 30)"
          @click="getEntrepriseInfo(a.h, a.n)"
          :key="a.id"
          class="e_card"
          :style="[
            a.v == 1
              ? {
                  borderBottom: '2px solid green',
                }
              : {
                  borderBottom: '2px solid red',
                },
          ]"
        >
          <div style="font-size: 1.2em; font-weight: bold">
            {{ a.nc }} {{ a.n }}
          </div>
          <div style="font-size: 0.9em">
            <div class="description">
              {{ a.a }}
            </div>
            <div class="description">
              {{ a.s }}
            </div>
            <div class="description">
              {{ a.cn }}
            </div>
          </div>

          <div class="description">
            Code initial espace entreprise : {{ a.nip }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AssureInfo from "@/components/AssureInfo";

export default {
  name: "portefeuille",
  components: {
    AssureInfo,
  },
  data: function () {
    return {
      searchInput: "",
      noResult: false,
      result: [],
      timeout: null,
      _timeOut: 2000,

      searchWhat: "A",
      placeHolder: "Nom, Prenom, Numéro de sécurité sociale ...",
    };
  },
  watch: {
    searchWhat(sw) {
      this.$router.push({ name: "assure" });
      this.result = [];
      this.searchInput = "";
      if (sw === "A")
        this.placeHolder = "Nom, Prenom, Numéro de sécurité sociale ...";
      if (sw === "E")
        this.placeHolder = "Nº client, Nº Siret, Raison social ...";
    },
    searchInput(text) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.searchAssure(text);
      }, 500);
    },
  },
  methods: {
    searchAssure(text) {
      this.noResult = false;
      if (text == "") {
        this.result = [];
        return;
      }
      this.axios
        .post("searchAssure", { text: text, what: this.searchWhat })
        .then((r) => {
          this.result = r.data;
          setTimeout(() => {
            if (this.searchResultNumber == 0) this.noResult = true;
          }, 10);
        });
    },
    getAssureInfo(numSS) {
      this.$router.push({
        name: "assure",
        params: {
          numSS: numSS,
        },
      });
    },
    getEntrepriseInfo(numHolding, numEntreprise) {
      this.$router.push({
        name: "portefeuille",
        params: {
          subPage: "ec",
          numHolding: numHolding,
          numEntreprise: numEntreprise,
        },
      });
    },
  },
  computed: {
    searchedAssure() {
      return this.result.filter((a) => {
        return a;
      });
    },
    searchResultNumber() {
      return this.result.length;
    },
    showAssureInfo() {
      return !!this.$route.params.numSS;
    },
  },
  mounted() {},
};
</script>
<style media="screen">
.recherche_area {
  padding: 70px 10px 0 70px;
  position: relative;
}
div#find_what {
  text-align: center;
}
div#no_result {
  font-size: 2em;
  margin: 30px 0;
  text-align: center;
  color: gray;
}
.search_input {
  padding: 30px 0;
  width: 420px;
  margin: auto;
}
.search_result {
  margin: 0 20px 0 10px;
  text-align: center;
}
div#searchResultNumber {
  margin: 5px 0 0 4px;
  color: #565656;
  text-shadow: 0 0 1px #bfbfbf;
}
.a_card {
  width: 300px;
  box-shadow: 0 0 2px 0 grey;
  margin: 10px;
  padding: 10px;
  border-radius: 4px;
  background-color: white;
  min-height: 70px;
  display: inline-block;
  text-align: left;
  cursor: pointer;
}
.e_card {
  width: 400px;
  box-shadow: 0 0 2px 0 grey;
  margin: 10px;
  padding: 10px;
  border-radius: 4px;
  background-color: white;
  min-height: 130px;
  display: inline-block;
  text-align: left;
  vertical-align: top;
  cursor: pointer;
}
div#userInfo {
  width: 800px;
  margin: auto;
  min-height: 600px;
  background-color: white;
  padding: 20px;
  box-shadow: 0 1px 3px 0 #d4d4d5, 0 0 0 1px #d4d4d5;
  border-radius: 6px;
  position: relative;
}
.ferme {
  position: absolute;
  right: 8px;
  top: 10px;
  padding-bottom: 13px;
  border-bottom: 2px solid;
}
</style>
